import type { AdType } from '@/modules/adv/types'

import type { HbBidderConfig } from '../types'

const ZONE_IDS: Partial<Record<AdType, number>> = {
    interstitial_preroll: 1679360,
    interstitial: 1679361,
    rewarded: 1679362,
    universal_banner_1: 1679363,
    universal_banner_short_1: 1679363,
    universal_banner_2: 1679363,
    leaderboard: 1679364,
    sidebar: 1679365,
    sidebar_bottom: 1679366,
    sticky_desktop: 1679367,
    sticky_mobile: 1679368,
}

export const GENIEE: HbBidderConfig = {
    bidder: 'ssp_geniee',
    params: ({ placement }) => ({
        zoneId: ZONE_IDS[placement] ?? 1679361,
        currency: 'USD',
    }),
}
